<div mat-dialog-title>
  <h3 class="flex-item">{{ 'envelopeOrdersPopup.envelopeOrders' | transloco }}</h3>
  <mat-form-field class="flex-item flex-container" appearance="outline">
    <mat-label>{{ 'common.labels.orderId' | transloco }}</mat-label>
    <input matInput [placeholder]="'common.labels.orderId' | transloco" [(ngModel)]="this.filterOrderID" (keyup)="onFilterOrder()">
  </mat-form-field>
</div>
<mat-dialog-content>
  @if (((envelopeOrders$ | async)?.length) ?? 0 > 0) {
    <div class="table-container">
      @if (((envelopeOrders$ | async)?.length) ?? 0 > 0) {
        <table mat-table [dataSource]="envelopeOrders$" multiTemplateDataRows
          >
          <ng-container matColumnDef="reference">
            <th mat-header-cell *matHeaderCellDef id="reference">{{ 'envelopeOrdersPopup.orderReference' | transloco }}</th>
            <td mat-cell *matCellDef="let eo"> {{ eo.orderReferenceNumber }} </td>
          </ng-container>
          <ng-container matColumnDef="orderID">
            <th mat-header-cell *matHeaderCellDef id="orderID">{{ 'common.labels.orderId' | transloco }}</th>
            <td mat-cell *matCellDef="let eo"> {{ eo.orderID }} </td>
          </ng-container>
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef id="type">{{ 'common.labels.orderType' | transloco }}</th>
            <td mat-cell *matCellDef="let eo"> {{ eo.orderType | enumLabel:'orderType' }} </td>
          </ng-container>
          <ng-container matColumnDef="order-status">
            <th mat-header-cell *matHeaderCellDef id="order-status">{{ 'common.labels.orderStatus' | transloco }}</th>
            <td mat-cell *matCellDef="let eo"> {{ eo.orderStatus | enumLabel:'orderStatusType' }} </td>
          </ng-container>
          <ng-container matColumnDef="external-status">
            <th mat-header-cell *matHeaderCellDef id="external-status">{{ 'envelopeOrdersPopup.externalStatus' | transloco }}</th>
            <td mat-cell *matCellDef="let eo"> {{ eo.externalStatus ?? '' }} </td>
          </ng-container>
          <ng-container matColumnDef="view">
            <th mat-header-cell *matHeaderCellDef id="view"> </th>
            <td mat-cell *matCellDef="let eo">
              <button mat-icon-button color="accent" (click)="viewOrder(eo)" [attr.aria-label]="'common.labels.viewOrder' | transloco">
                <mat-icon>visibility</mat-icon>
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef id="delete"> </th>
            <td mat-cell *matCellDef="let eo">
              <button mat-icon-button color="primary" (click)="onDelete(eo)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      }
    </div>
  } @else {
    <div class="flex-container-center">
      <span class="flex-item text-faded">{{ 'envelopeOrdersPopup.noOrdersFound' | transloco }}</span>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions class="flex-container-right-align">
  <div class="spacer"></div>
  <button class="flex-item-fixed-size" mat-raised-button [mat-dialog-close]="true">{{ 'common.buttons.close' | transloco }}</button>
</mat-dialog-actions>